import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertTriangle } from 'lucide-react';
export function CompatibilitySection() {
  const checks = ['Apto para preservativos de látex y poliuretano', 'Uso externo únicamente', 'No usar si hay alergia a algún componente (revisar ingredientes)', 'Lavar con agua si causa irritación leve'];
  return <section className="w-full bg-dark-800 py-20 px-4" data-id="element-34">
      <div className="max-w-4xl mx-auto bg-dark-700 rounded-2xl p-8 md:p-12 border border-white/5" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-36">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-37">
            COMPATIBILIDAD
          </h2>
          <p className="text-gray-400 text-sm uppercase tracking-wider" data-id="element-38">
            Aclaración importante
          </p>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-39">
          {checks.map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3" data-id="element-40">
              <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-41" />
              <span className="text-gray-200 font-medium" data-id="element-42">{text}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="flex items-start gap-3 p-4 bg-yellow-500/10 border border-yellow-500/20 rounded-lg" data-id="element-43">
          <AlertTriangle className="w-6 h-6 text-yellow-500 shrink-0 mt-0.5" data-id="element-44" />
          <span className="text-yellow-200/90 font-medium" data-id="element-45">
            No ingerir. Mantener fuera del alcance de niños.
          </span>
        </motion.div>
      </div>
    </section>;
}